import { Link } from 'react-router-dom';
import './bulletLink.css';

function BulletLink(props) {
  const { text, link, linkText } = props;
  return (
    <li>
      <div className="text">{text || ''}</div>
      {link && <Link to={link || '/'}> {linkText || ''} </Link>}
    </li>
  );
}

export default BulletLink;
